const RECOVERY_HEADING = "HelloConvo is finishing an update";
const RECOVERY_MESSAGE = "Please try again. Your work has not been changed.";

/**
 * Last-resort UI for an exception after the entry bundle has loaded. This is
 * intentionally DOM-only: React may be the code that failed to initialise.
 */
export function renderBootstrapRecovery(root: HTMLElement, releaseId?: string, developerMessage?: string): void {
  const section = document.createElement("main");
  section.dataset.hcBootstrapRecovery = "1";
  if (releaseId) section.dataset.hcRelease = releaseId;
  section.style.cssText = [
    "min-height:100vh",
    "display:grid",
    "place-content:center",
    "gap:12px",
    "padding:32px",
    "font-family:ui-sans-serif,system-ui,sans-serif",
    "color:#172554",
    "background:#f8fafc",
  ].join(";");

  const heading = document.createElement("h1");
  heading.textContent = RECOVERY_HEADING;
  heading.style.margin = "0";

  const message = document.createElement("p");
  message.setAttribute("role", "alert");
  message.textContent = RECOVERY_MESSAGE;
  message.style.margin = "0";

  const retry = document.createElement("button");
  retry.type = "button";
  retry.textContent = "Try again";
  retry.style.cssText = "width:max-content;padding:10px 16px;border:0;border-radius:6px;background:#1d4ed8;color:white;font:inherit;font-weight:600;cursor:pointer";
  retry.addEventListener("click", () => window.location.reload());

  section.append(heading, message, retry);
  if (developerMessage) {
    const details = document.createElement("details");
    const summary = document.createElement("summary");
    summary.textContent = "Developer details";
    const pre = document.createElement("pre");
    pre.textContent = developerMessage;
    pre.style.whiteSpace = "pre-wrap";
    details.append(summary, pre);
    section.append(details);
  }
  root.replaceChildren(section);
}
